// TODO: (Vlad) move MagicLink constants from services after release
export const MagicLinkConstants = {
  shops: {
    apple: 'https://apps.apple.com/us/app/fr8bot/id6761719112',
    google: 'https://play.google.com/store/apps/details?id=com.fr8bot.data',
  },
  storeFallbackDelay: 5_000,
};
